import { render, staticRenderFns } from "./btnQuestion.vue?vue&type=template&id=aabc0f70"
import script from "./btnQuestion.vue?vue&type=script&lang=js"
export * from "./btnQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports